Flup.init(function (flup) {
    $('#account-publications-table').ddTableFilter();
    $(".table-row-header").find("select").css( "border", "0" )
})